import { createApp } from 'vue'
import { createPinia } from "pinia";
import App from './App.vue'
import "./assets/styles.css";
import router from './router'
import Vue3Lottie from 'vue3-lottie'

const pinia = createPinia();

createApp(App)
    .use(router)
    .use(pinia)
    .use(Vue3Lottie)
    .mount('#app')
